import { render } from "./TableCol.vue?vue&type=template&id=76d36ab3"
import script from "./TableCol.vue?vue&type=script&lang=js"
export * from "./TableCol.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__